import { AnyAction } from "redux";
import { FindById, Update } from "../../../commonsCapacities";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { CommonsCapacitiesAdapter } from "../../../../adapter/commonsCapacities-adapter";

export const FETCH_UPDATE_COMMONS_CAPACITIES_REQUEST = 'FETCH_UPDATE_COMMONS_CAPACITIESS_CAPACITIES_REQUEST';
export const FETCH_UPDATE_COMMONS_CAPACITIES_SUCCESS = 'FETCH_UPDATE_COMMONS_CAPACITIES_SUCCESS';
export const FETCH_UPDATE_COMMONS_CAPACITIES_FAILURE = 'FETCH_UPDATE_COMMONS_CAPACITIES_FAILURE';
export const SET_UPDATE_COMMONS_CAPACITIES = 'SET_UPDATE_COMMONS_CAPACITIES';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchUpdateCommonsCapacitiesRequest = () => {
    return {
        type: FETCH_UPDATE_COMMONS_CAPACITIES_REQUEST,
    };
};

const fetchUpdateCommonsCapacitiesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_UPDATE_COMMONS_CAPACITIES_SUCCESS,
        payload: data
    };
};

const fetchUpdateCommonsCapacitiesFailure = (error: any) => {
    return {
        type: FETCH_UPDATE_COMMONS_CAPACITIES_FAILURE,
        payload: error,
    };
};

export const setUpdateCommonsCapacities = (data: any) => {
    return {
        type: SET_UPDATE_COMMONS_CAPACITIES,
        payload: data,
    };
};

export const update = (id: string, data: any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateCommonsCapacitiesRequest());
        try {
            const response = await Update(id, data);
            dispatch(fetchUpdateCommonsCapacitiesSuccess(
                Adapter.from(response.data).to((value) => new CommonsCapacitiesAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchUpdateCommonsCapacitiesFailure(error.message));
        }
    };
};

export const findById = (id: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateCommonsCapacitiesRequest());
        try {
            const response = await FindById(id);
            dispatch(setUpdateCommonsCapacities(
               response.data
            ));
        } catch (error: any) {
            dispatch(fetchUpdateCommonsCapacitiesFailure(error.message));
        }
    };
};
